import { useEffect, useState } from 'react';

enum DisplaySize {
  small = 'small',
  medium = 'medium',
  large = 'large',
}

interface DisplaySizeStatus {
  isSmallScreen: boolean;
  isMediumScreen: boolean;
  isLargeScreen: boolean;
}

const getDisplaySize = (): DisplaySize => {
  const rootStyles = getComputedStyle(document.documentElement);
  return rootStyles.getPropertyValue('--display-size') as DisplaySize;
};

const useDisplaySize = (): DisplaySizeStatus => {
  const [displaySize, setDisplaySize] = useState<DisplaySize>(getDisplaySize);

  useEffect(() => {
    const handleResize = () => {
      setDisplaySize(getDisplaySize);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return {
    isSmallScreen: displaySize === DisplaySize.small,
    isMediumScreen: displaySize === DisplaySize.medium,
    isLargeScreen: displaySize === DisplaySize.large,
  };
};

export default useDisplaySize;
